import React from 'react';
import '../template-file-css/document-file-template.css';



export const LaGeneral_WellnessAssessmentAdult = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LaGeneral_WellnessAssessmentAdult' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><center><span className='eleHeader'>Wellness Assessment - Adult</span></center></p>
                <p className='w-750'>
                    Completing this brief questionnaire will help us provide services that meet your needs. Answer each question as
                    best you can and then review your responses with your clinician. Please shade circles like this
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span><b>Visit #: </b></span>
                            <input type='radio' id='rbVisit1' name='rbVisit' className='add-only' value='1 or 2' /> 1 or 2 &nbsp;
                            <input type='radio' id='rbVisit3' name='rbVisit' className='add-only' value='3 to 5' /> 3 to 5 &nbsp;
                            <input type='radio' id='rbOther' name='rbVisit' className='add-only' value='Other' /> Other
                        </td>
                    </tr>
                </table>

                <p className='w-750'><center><h3>For questions 1-16, please think about your experience in the past week.</h3></center></p>
                
                <table className='w-750'>
                    <tr>
                        <td className='w-350'><span className='eleHeader'>How much did the following problems bother you?</span></td>
                        <td className='w-100'><span className='eleHeader'>Not at All</span></td>
                        <td className='w-100'><span className='eleHeader'>A Little</span></td>
                        <td className='w-100'><span className='eleHeader'>Somewhat</span></td>
                        <td className='w-100'><span className='eleHeader'>A Lot</span></td>
                    </tr>
                    <tr>
                        <td className='w-350'><span>1. Nervousness or shakiness</span></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbNotAtAll_1' name='rbNervousnessOrShakiness' className='add-only' value='Not at All' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLittle_1' name='rbNervousnessOrShakiness' className='add-only' value='Little' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbSomewhat_1' name='rbNervousnessOrShakiness' className='add-only' value='Somewhat' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLot_1' name='rbNervousnessOrShakiness' className='add-only' value='Lot' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'><span>2. Feeling sad or blue</span></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbNotAtAll_2' name='rbFeelingSadOrBlue' className='add-only' value='Not at All' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLittle_2' name='rbFeelingSadOrBlue' className='add-only' value='Little' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbSomewhat_2' name='rbFeelingSadOrBlue' className='add-only' value='Somewhat' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLot_2' name='rbFeelingSadOrBlue' className='add-only' value='Lot' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'><span>3. Feeling hopeless about the future</span></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbNotAtAll_3' name='rbFeelingHopeless' className='add-only' value='Not at All' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLittle_3' name='rbFeelingHopeless' className='add-only' value='Little' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbSomewhat_3' name='rbFeelingHopeless' className='add-only' value='Somewhat' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLot_3' name='rbFeelingHopeless' className='add-only' value='Lot' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'><span>4. Feeling everything is an effort</span></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbNotAtAll_4' name='rbFeelingEverything' className='add-only' value='Not at All' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLittle_4' name='rbFeelingEverything' className='add-only' value='Little' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbSomewhat_4' name='rbFeelingEverything' className='add-only' value='Somewhat' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLot_4' name='rbFeelingEverything' className='add-only' value='Lot' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'><span>5. Feeling no interest in things</span></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbNotAtAll_5' name='rbFeelingNoInterest' className='add-only' value='Not at All' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLittle_5' name='rbFeelingNoInterest' className='add-only' value='Little' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbSomewhat_5' name='rbFeelingNoInterest' className='add-only' value='Somewhat' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLot_5' name='rbFeelingNoInterest' className='add-only' value='Lot' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'><span>6. Your heart pounding or racing</span></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbNotAtAll_6' name='rbHeartPounding' className='add-only' value='Not at All' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLittle_6' name='rbHeartPounding' className='add-only' value='Little' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbSomewhat_6' name='rbHeartPounding' className='add-only' value='Somewhat' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLot_6' name='rbHeartPounding' className='add-only' value='Lot' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'><span>7. Trouble sleeping</span></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbNotAtAll_7' name='rbTroubleSleeping' className='add-only' value='Not at All' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLittle_7' name='rbTroubleSleeping' className='add-only' value='Little' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbSomewhat_7' name='rbTroubleSleeping' className='add-only' value='Somewhat' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLot_7' name='rbTroubleSleeping' className='add-only' value='Lot' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'><span>8. Feeling fearful or afraid</span></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbNotAtAll_8' name='rbFeelingFearful' className='add-only' value='Not at All' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLittle_8' name='rbFeelingFearful' className='add-only' value='Little' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbSomewhat_8' name='rbFeelingFearful' className='add-only' value='Somewhat' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLot_8' name='rbFeelingFearful' className='add-only' value='Lot' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'><span>9. Difficulty at home</span></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbNotAtAll_9' name='rbDifficultyAtHome' className='add-only' value='Not at All' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLittle_9' name='rbDifficultyAtHome' className='add-only' value='Little' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbSomewhat_9' name='rbDifficultyAtHome' className='add-only' value='Somewhat' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLot_9' name='rbDifficultyAtHome' className='add-only' value='Lot' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'><span>10. Difficulty socially</span></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbNotAtAll_10' name='rbDifficultySocially' className='add-only' value='Not at All' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLittle_10' name='rbDifficultySocially' className='add-only' value='Little' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbSomewhat_10' name='rbDifficultySocially' className='add-only' value='Somewhat' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLot_10' name='rbDifficultySocially' className='add-only' value='Lot' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'><span>11. Difficulty at work or school</span></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbNotAtAll_11' name='rbDifficultyAtWork' className='add-only' value='Not at All' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLittle_11' name='rbDifficultyAtWork' className='add-only' value='Little' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbSomewhat_11' name='rbDifficultyAtWork' className='add-only' value='Somewhat' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLot_11' name='rbDifficultyAtWork' className='add-only' value='Lot' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-350'><span className='eleHeader'>How much do you agree with the following?</span></td>
                        <td className='w-100'><span className='eleHeader'>Strongly Agree</span></td>
                        <td className='w-100'><span className='eleHeader'>Agree</span></td>
                        <td className='w-100'><span className='eleHeader'>Disagree</span></td>
                        <td className='w-100'><span className='eleHeader'>Strongly Disagree</span></td>
                    </tr>
                    <tr>
                        <td className='w-350'><span>12. I feel good about myself</span></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbblyAgree_1' name='rbGoodAboutMyself' className='add-only' value='bly Agree' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbAgree_1' name='rbGoodAboutMyself' className='add-only' value='Agree' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbDisagree_1' name='rbGoodAboutMyself' className='add-only' value='Disagree' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbblyDisagree_1' name='rbGoodAboutMyself' className='add-only' value='bly Disagree' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'><span>13. I can deal with my problems</span></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbblyAgree_2' name='rbMyProblems' className='add-only' value='bly Agree' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbAgree_2' name='rbMyProblems' className='add-only' value='Agree' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbDisagree_2' name='rbMyProblems' className='add-only' value='Disagree' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbblyDisagree_2' name='rbMyProblems' className='add-only' value='bly Disagree' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'><span>14. I am able to accomplish the things I want</span></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbblyAgree_3' name='rbAccomplish' className='add-only' value='bly Agree' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbAgree_3' name='rbAccomplish' className='add-only' value='Agree' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbDisagree_3' name='rbAccomplish' className='add-only' value='Disagree' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbblyDisagree_3' name='rbAccomplish' className='add-only' value='bly Disagree' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'><span>15. I have friends or family that I can count on for help</span></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbblyAgree_4' name='rbFriendsOrFamily' className='add-only' value='bly Agree' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbAgree_4' name='rbFriendsOrFamily' className='add-only' value='Agree' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbDisagree_4' name='rbFriendsOrFamily' className='add-only' value='Disagree' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbblyDisagree_4' name='rbFriendsOrFamily' className='add-only' value='bly Disagree' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span>16. In the past week, approximately how many drinks of alcohol did you have? </span>
                            <input type='text' id='txtDrinksOfAlcohol' name='txtDrinksOfAlcohol' className='add-only w-150 custom-add-only' /> Drinks
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span><b>Please answer the following questions only if this is your first time completing this questionnaire.</b></span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>17. In general, would you say your health is: </span><br />
                            <input type='radio' id='rbExcellent' name='rbHealth' className='add-only' value='Excellent' /> Excellent &nbsp;
                            <input type='radio' id='rbVeryGood' name='rbHealth' className='add-only' value='Very Good' /> Very Good &nbsp;
                            <input type='radio' id='rbGood' name='rbHealth' className='add-only' value='Good' /> Good &nbsp;
                            <input type='radio' id='rbFair' name='rbHealth' className='add-only' value='Fair' /> Fair &nbsp;
                            <input type='radio' id='rbPoor' name='rbHealth' className='add-only' value='Poor' /> Poor
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>18. Please indicate if you have a serious or chronic medical condition: </span><br />
                            <input type='radio' id='rbAsthma' name='rbChronicMedicalCondition' className='add-only' value='Asthma' /> Asthma &nbsp;
                            <input type='radio' id='rbDiabetes' name='rbChronicMedicalCondition' className='add-only' value='Diabetes' /> Diabetes &nbsp;
                            <input type='radio' id='rbHeartDisease' name='rbChronicMedicalCondition' className='add-only' value='Heart Disease' /> Heart Disease &nbsp;
                            <input type='radio' id='rbOtherChronicPain' name='rbChronicMedicalCondition' className='add-only' value='Back Pain or Other Chronic Pain' /> Back Pain or Other Chronic Pain &nbsp;
                            <input type='radio' id='rbOtherCondition' name='rbChronicMedicalCondition' className='add-only' value='Other Condition' /> Other Condition
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>19. In the past 6 months, how many times did you visit a medical doctor? </span><br />
                            <input type='radio' id='rbMedicalDoctor_1' name='rbMedicalDoctor' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbMedicalDoctor_2' name='rbMedicalDoctor' className='add-only' value='1' /> 1 &nbsp;
                            <input type='radio' id='rbMedicalDoctor_3' name='rbMedicalDoctor' className='add-only' value='2-3' /> 2-3 &nbsp;
                            <input type='radio' id='rbMedicalDoctor_4' name='rbMedicalDoctor' className='add-only' value='4-5' /> 4-5 &nbsp;
                            <input type='radio' id='rbMedicalDoctor_5' name='rbMedicalDoctor' className='add-only' value='6+' /> 6+
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>20. In the past month, how many days were you unable to work because of your physical or mental health? (answer only if employed)</span>
                            <input type='text' id='txtPhysicalOrMentalHealth' name='txtPhysicalOrMentalHealth' className='add-only w-250 custom-add-only' /> Days
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>21. In the past month, how many days were you able to work but had to cut back on how much you got done because of your physical or mental health? (answer only if employed)</span>
                            <input type='text' id='txtYourPhysicalOrMentalHealth' name='txtYourPhysicalOrMentalHealth' className='add-only w-250 custom-add-only' /> Days
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>22. In the past month have you ever felt you ought to cut down on your drinking or drug use? </span>
                            <input type='radio' id='rbDrinkingOrDrugUseY' name='rbDrinkingOrDrugUse' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbDrinkingOrDrugUseN' name='rbDrinkingOrDrugUse' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>23. In the past month have you ever felt annoyed by people criticizing your drinking or drug use? </span>
                            <input type='radio' id='rbCriticizingDrinkingOrDrugUseY' name='rbCriticizingDrinkingOrDrugUse' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbCriticizingDrinkingOrDrugUseN' name='rbCriticizingDrinkingOrDrugUse' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>24. In the past month have you felt bad or guilty about your drinking or drug use? </span>
                            <input type='radio' id='rbGuiltyAboutDrinkingOrDrugUseY' name='rbGuiltyAboutDrinkingOrDrugUse' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbGuiltyAboutDrinkingOrDrugUseN' name='rbGuiltyAboutDrinkingOrDrugUse' className='add-only' value='No' /> No
                        </td>
                    </tr>
                </table>


            </div>
        </form >

    )
}











